import { ORIGIN_HOST } from '@unreserved-frontend-v2/utils/local-storage/constants'
import { BreadcrumbItem } from './types'

type SchemaBreadcrumbListItem = {
  position: number
  '@type': 'ListItem'
  name?: string
  item?: { '@id': string; name: string; url?: string }
}

export const getSchemOrgBreadcrumbsList = (breadcrumbItems: BreadcrumbItem[], originHost = ORIGIN_HOST) => {
  return JSON.stringify(
    breadcrumbItems.reduce(
      (breadcrumbSchema, { label: name, url }, indx, arr) => {
        if (name && indx > 0) {
          const fullURL = `${originHost}${url}`
          const itemListElement: SchemaBreadcrumbListItem = {
            '@type': 'ListItem',
            position: indx,
          }
          if (indx < arr.length - 1) {
            itemListElement.item = {
              name,
              '@id': fullURL.replace('https://', '').replace('http://', ''),
              url: fullURL,
            }
          } else {
            // Note that "url" is omitted from the final list item since the current URL is where the list terminates.
            itemListElement.name = name
          }

          breadcrumbSchema.itemListElement.push(itemListElement)
        }
        return breadcrumbSchema
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [] as SchemaBreadcrumbListItem[],
      }
    )
  )
}
